import { defineComponent as _defineComponent } from 'vue'
import OzContainedButton, { OzContainedButtonSizePreset } from '@@/library/v4/components/OzContainedButton.vue'
import { useWindowSizeStore } from '@@/pinia/window_size'
import { storeToRefs } from 'pinia'


export default /*#__PURE__*/_defineComponent({
  __name: 'SkipToContentLink',
  props: {
    contentElementSelector: { default: '#main-content' }
  },
  setup(__props: any) {

const props = __props as { contentElementSelector: string };



const windowSizeStore = useWindowSizeStore()
const { isSmallerThanTabletLandscape } = storeToRefs(windowSizeStore)

const onClick = (event: MouseEvent): boolean => {
  event.preventDefault()
  const contentElement = document.querySelector(props.contentElementSelector) as HTMLElement
  if (contentElement != null) contentElement.focus()
  return false
}

return { __sfc: true,props, windowSizeStore, isSmallerThanTabletLandscape, onClick, OzContainedButton, OzContainedButtonSizePreset }
}

})